import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'dva/router';
import { Col, Form, Input } from 'antd';
import styles from './../common.less';

const Search = Input.Search;
const FormItem = Form.Item;

class SearchComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldPlaceholder: this.props.fieldPlaceholder || this.props.intl.formatMessage({ id: 'Common.Search' }),
    };
  }

  onSearch() {
    let searchValue = this.props.form.getFieldValue('searchString');
    searchValue = searchValue || String(searchValue).length > 0 ? `*${searchValue}*` : undefined;
    const filter = Object.assign(this.props.self.state.filter, { search: searchValue });
    this.props.self.setState({ filter });
  }

  render() {
    return (
      <Form>
        <Col span={this.props.span || 10}>
          <FormItem
            colon={false}
            className={styles.noMarginBottom}
          >
            {this.props.form.getFieldDecorator('searchString', {})(
              <Search
                maxLength={255}
                onSearch={this.onSearch.bind(this)}
                placeholder={this.state.fieldPlaceholder}
              />,
            )}
          </FormItem>
        </Col>
      </Form>
    );
  }
}

export default withRouter(Form.create()(injectIntl(SearchComponent)));



// WEBPACK FOOTER //
// ./src/components/SearchComponent/SearchComponent.js